import React from 'react';
import MainLayout from '../layout/MainLayout';
import Participant from '../components/Participant/Participant';
import DashboardDefault from '../pages/dashboard';
import ParticipantDetails from '../components/Participant/ParticipantDetails';
import EpisodeList from '../components/Episode/EpisodeList';
import ActivityList from '../components/Activity/ActivityList';
import AuthorizationList from '../components/Authorization/AuthorizationList';
import TreatmentList from '../components/Treatment/TreatmentList';
import ContactList from '../components/Contact/ContactList';
import OrganizationList from '../components/Organization/OrganizationList';
import ComplianceList from '../components/Compliance/ComplianceList';
import VerificationList from '../components/Verification/VerificationList';
import ReportList from '../components/Report/ReportList';
import CdcrReportList from '../components/CdcrReport/CdcrReportList';
import PrintCdcr from '../components/CdcrReport/Print/PrintCDCR';
import EpisodeDetail from '../components/Episode/EpisodeDetail';
import CBPList from '../components/Cbp/CBPList';
import CbpForm from '../components/Cbp/CBPForms/CbpForm';
import DetailsSearch from '../components/DetailsSearch/DetailsSearch';
import VerificationDetails from '../components/Verification/VerificationDetails';
import VerificationsCreate from '../components/Verification/VerificationCreate';
import ContactForm from '../components/Contact/ContactForm/ContactForm';
import OrganizationDetail from '../components/Organization/OrganizationDetail/OrganizationDetail';
import InvoiceList from '../components/Invoices/InvoiceList/InvoiceList';
import CbpInvoiceList from '../components/Invoices/CbpInvoiceList/CbpInvoiceList';
import PrintInvoices from '../components/Invoices/InvoiceList/Print/PrintInvoices';
import TransportationInvoiceList from '../components/Invoices/TransportationInvoiceList/TransportationInvoiceList';
import InvoiceHistoryList from '../components/Invoices/InvoiceHistoryList/InvoiceHistoryList';
import OutOfMonthTreatmentsList from '../components/Invoices/OutOfMonthTreatmentsList/OutOfMonthTreatmentsList';
import CreditedTreatmentsList from '../components/Invoices/CreditedTreatmentsList/CreditedTreatmentsList';
import AuthDebug from '../layout/MainLayout/Header/HeaderContent/AuthDebug'
import DirectoryList from '../components/Report/DirectoryList';
import WeeklyParole from '../components/Report/WeeklyParole';
import CompletionRatio from '../components/Report/CompletionRatio/CompletionRatio';
import CompletionRatioAge from '../components/Report/CompletionRatio/CompletionRatioAge';
import CompletionRatioEthnicity from '../components/Report/CompletionRatio/CompletionRatioEthnicity';
import CompletionRatioFunding from '../components/Report/CompletionRatio/CompletionRatioFunding';
import QueryBuilderPage from '../components/QueryBuilder/QueryBuilderPage';

const MainRoutes = {
  path: '/',
  element: <MainLayout />,
  children: [
    {
      path: '/',
      element: <DashboardDefault />,
    },
    {
      path: 'dashboard',
      children: [
        {
          path: 'default',
          element: <DashboardDefault />,
        },
      ],
    },
    {
      path: '/participants/details/:id',
      element: <ParticipantDetails />,
    },
    {
      path: '/participants/details',
      element: <DetailsSearch />,
    },
    {
      path: 'participants',
      element: <Participant />,
    },
    {
      path: 'episode/details/:id',
      element: <EpisodeDetail />,
    },
    {
      path: '/episodes/details',
      element: <DetailsSearch />,
    },
    {
      path: 'episodes',
      element: <EpisodeList />,
    },
    {
      path: '/activity/details',
      element: <DetailsSearch />,
    },
    {
      path: 'activity',
      element: <ActivityList />,
    },
    {
      path: '/authorization/details',
      element: <DetailsSearch />,
    },
    {
      path: 'authorization',
      element: <AuthorizationList />,
    },
    {
      path: '/treatment/details',
      element: <DetailsSearch />,
    },
    {
      path: 'treatment',
      element: <TreatmentList />,
    },
    {
      path: '/reports/details',
      element: <DetailsSearch />,
    },
    {
      path: 'reports',
      element: <ReportList />,
    },
    {
      path: '/cdcrReport/details',
      element: <DetailsSearch />,
    },
    {
      path: 'cdcrReport',
      element: <CdcrReportList />,
    },
    {
      path: '/cdcr/print',
      element: <PrintCdcr />,
    },
    {
      path: 'weeklyVerification',
      element: <VerificationList />,
    },
    {
      path: 'weeklyVerification/:id',
      element: <VerificationList />,
    },
    {
      path: '/weeklyVerification/details',
      element: <DetailsSearch />,
    },
    {
      path: '/weeklyVerification/details/:id',
      element: <VerificationDetails />,
    },
    {
      path: '/weeklyVerification/create',
      element: <VerificationsCreate />,
    },
    {
      path: '/cbp/details/:id',
      element: <CbpForm />,
    },
    {
      path: '/cbp/details',
      element: <DetailsSearch />,
    },
    {
      path: 'cbp',
      element: <CBPList />,
    },
    {
      path: '/participants/details',
      element: <DetailsSearch />,
    },
    {
      path: '/contacts/details/:id',
      element: <ContactForm />,
    },
    {
      path: '/contacts/details',
      element: <DetailsSearch />,
    },
    {
      path: 'contacts',
      element: <ContactList />,
    },
    {
      path: '/contractsCompliance/details',
      element: <DetailsSearch />,
    },
    {
      path: 'contractsCompliance',
      element: <ComplianceList />,
    },
    {
      path: '/organizations/details/:id',
      element: <OrganizationDetail />,
    },
    {
      path: '/organizations/details',
      element: <DetailsSearch />,
    },
    {
      path: 'organizations',
      element: <OrganizationList />,
    },
    {
      path: '/invoice/cbpInvoiceList/:id',
      element: <CbpInvoiceList />,
    },
    {
      path: '/invoice/cbpInvoiceList',
      element: <CbpInvoiceList />,
    },
    {
      path: '/invoice/invoiceHistoryList',
      element: <InvoiceHistoryList />,
    },
    {
      path: '/invoice/PrintInvoices',
      element: <PrintInvoices />,
    },
    {
      path: '/invoice/transportationInvoiceList/:id',
      element: <TransportationInvoiceList />,
    },
    {
      path: '/invoice/outOfMonthTreatmentsList',
      element: <OutOfMonthTreatmentsList />,
    },
    {
      path: '/invoice/creditedTreatmentsList',
      element: <CreditedTreatmentsList />,
    },
    {
      path: 'invoice',
      element: <InvoiceList />,
    },
    {
      path: 'auth-debug',
      element: <AuthDebug />,
    },
    {
      path: 'report/directory/:asOfDate',
      element: <DirectoryList />,
    },
    {
      path: 'report/weekly/:startDate/:endDate/:countyID',
      element: <WeeklyParole />,
    },
    {
      path: 'report/completion',
      element: <CompletionRatio />,
    },
    {
      path: 'report/completion/age',
      element: <CompletionRatioAge />,
    },
    {
      path: 'report/completion/ethnicity',
      element: <CompletionRatioEthnicity />,
    },
    {
      path: 'report/completion/funding',
      element: <CompletionRatioFunding />,
    },
    {
      path: 'query-builder',
      element: <QueryBuilderPage />,
    },
  ],
};

export default MainRoutes;
